import { esApp } from './plataforma';

/**
 * Que la app ocupe toda la pantalla, también bajo el notch y la barra de inicio.
 *
 * Sin `viewport-fit=cover`, `env(safe-area-inset-*)` vale 0 y el notch tapa la barra superior. Con
 * él, las barras se apartan solas (`safe-area-top` / `safe-area-bottom`).
 *
 * 🔴 Solo en la app, y por eso se pone al arrancar y no en `index.html`: en Safari de iPhone, en
 * horizontal, la isla taparía el principio de la cabecera y del texto (comprobado en simulador el
 * 15-oct-2026). La app va solo en vertical (`tooling/soloVertical.test.ts`). WebKit aplica el
 * cambio aunque la página ya esté cargada: también comprobado.
 */
export const ocuparPantallaCompleta = (): void => {
	if (!esApp()) {
		return;
	}

	const meta = document.querySelector('meta[name="viewport"]');
	if (!meta) {
		return;
	}

	const contenido = meta.getAttribute('content') ?? '';
	if (contenido.includes('viewport-fit')) {
		return;
	}

	meta.setAttribute('content', [contenido, 'viewport-fit=cover'].filter(Boolean).join(', '));
};
